






































































import Vue from 'vue';
import { AutoCompleteInput, OutlinedTextInput } from '@/components/ds';
import { searchZipCode } from '@/helpers/externalServices';
import { formatZipCode } from '@/helpers/formatters';
import {
  AutocompleteOption,
  parseToAutocompleteOptionArray,
  parseToAutocompleteOption,
} from '@/helpers/autocomplete';

export interface AddressFormEvent {
  city: string;
  zipCode: string;
  neighborhood: string;
  street: string;
  number: string;
  complement: string;
  state: string;
}

export default Vue.extend({
  components: { AutoCompleteInput, OutlinedTextInput },
  props: {
    currentState: {
      type: String,
      default: '',
    },
    currentZipCode: {
      type: String,
      default: '',
    },
    currentNeighborhood: {
      type: String,
      default: '',
    },
    currentStreet: {
      type: String,
      default: '',
    },
    currentNumber: {
      type: String,
      default: '',
    },
    currentComplement: {
      type: String,
      default: '',
    },
    currentCity: {
      type: String,
      default: '',
    },
  },
  data() {
    return {
      mask: formatZipCode,
      addressForm: {
        state: this.currentState,
        zipCode: this.currentZipCode,
        neighborhood: this.currentNeighborhood,
        street: this.currentStreet,
        number: this.currentNumber,
        complement: this.currentComplement,
        city: this.currentCity,
      } as AddressFormEvent,
      disabled: {
        neighborhood: true,
        street: true,
      },
    };
  },
  computed: {
    getStates(): AutocompleteOption[] {
      return parseToAutocompleteOptionArray(this.$store.getters.statesOptions) || [];
    },
    selectedState(): AutocompleteOption {
      return parseToAutocompleteOption(this.addressForm.state);
    },
  },
  created() {
    this.$store.dispatch('PULL_STATES_OPTIONS');
  },
  methods: {
    inputHandler() {
      const event: AddressFormEvent = this.addressForm;
      this.$emit('input', event);
    },
    async completeAddress(zipCode: string) {
      await searchZipCode(zipCode).then(result => {
        this.addressForm.neighborhood = result?.neighborhood || '';
        this.addressForm.street = result?.street || '';
        this.addressForm.city = result?.city || '';

        this.disabled.neighborhood = result ? Boolean(result?.neighborhood) : false;
        this.disabled.street = result ? Boolean(result?.street) : false;
      });
    },
    selectHandlerState(option: AutocompleteOption) {
      this.addressForm.state = option.value;
      this.inputHandler();
    },
  },
});
